<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

@if (data.primaryButton) {
    <div class="context-cta-container">
        <button
            mat-button
            class="font-button2"
            (click)="primaryButtonClick($event)"
            [disabled]="data.primaryButton.isDisabled"
        >
            {{ data.primaryButton.text | translate }}
        </button>
        @if (data.secondaryButton) {
            <button
                mat-button
                class="font-button2"
                (click)="secondaryButtonClick($event)"
                [disabled]="data.secondaryButton.isDisabled"
            >
                {{ data.secondaryButton.text | translate }}
            </button>
        }
    </div>
}
